<template>
  <Disclosure as="nav">
    <div class="z-30 w-full">
      <div class="flex justify-end">
        <ProfileDropDown class="mt-4 mr-4 sm:mr-8 md:mr-12 lg:mr-20" />
      </div>
    </div>
  </Disclosure>
</template>

<script>
import { Disclosure } from "@headlessui/vue";
import ProfileDropDown from "./ProfileDropDown.vue";
export default {
  components: {
    Disclosure,
    ProfileDropDown,
  },
};
</script>
